// Cart drawer scroll items slider 

(function () {
    var scrollItemsSwiper = null;
    var scrollResizeObserver = null;
    var drawerObserver = null;

    function destroySwiper() {
        if (scrollResizeObserver) {
            scrollResizeObserver.disconnect();
            scrollResizeObserver = null;
        }
        if (scrollItemsSwiper && typeof scrollItemsSwiper.destroy === 'function') {
            scrollItemsSwiper.destroy(true, true);
            scrollItemsSwiper = null;
        }
    }

    function refreshSwiper() {
        if (scrollItemsSwiper && typeof scrollItemsSwiper.update === 'function') {
            scrollItemsSwiper.update();
        }
    }

    function initScrollItemsSlider() {
        if (typeof Swiper === 'undefined') return;

        var scrollEl = document.querySelector('.scroll-items-swiper');
        var paginationEl = document.querySelector('.scroll-items-pagination');
        if (!scrollEl || !paginationEl) {
            destroySwiper();
            return;
        }

        destroySwiper();

        scrollItemsSwiper = new Swiper(scrollEl, {
            slidesPerView: 1,
            spaceBetween: 10,
            loop: true,
            watchOverflow: true,
            observer: true,
            observeParents: true,
            pagination: {
                el: paginationEl,
                clickable: true,
                type: 'bullets',
            },
        });

        scrollResizeObserver = new ResizeObserver(function () {
            refreshSwiper();
        });
        scrollResizeObserver.observe(scrollEl);
    }

    function scheduleInit() {
        requestAnimationFrame(function () {
            initScrollItemsSlider();
        });
    }

    function bindCartDrawerRefresh() {
        var drawer = document.querySelector('cart-drawer');
        if (!drawer || drawer.dataset.scrollItemsSliderBound) return;
        drawer.dataset.scrollItemsSliderBound = 'true';

        drawerObserver = new MutationObserver(function () {
            if (drawer.classList.contains('active')) {
                requestAnimationFrame(function () {
                    if (scrollItemsSwiper) {
                        refreshSwiper();
                    } else {
                        scheduleInit();
                    }
                });
            }
        });
        drawerObserver.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }

    document.addEventListener('DOMContentLoaded', function () {
        scheduleInit();
        bindCartDrawerRefresh();
    });

    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
            scheduleInit();
        });
    }
})();


// cart drawer complementart products slider 

(function () {
    var swiperInstance = null;

    function destroySwiper() {
        if (swiperInstance && typeof swiperInstance.destroy === 'function') {
            swiperInstance.destroy(true, true);
            swiperInstance = null;
        }
    }

    function initCartComplementarySwiper() {
        if (typeof Swiper === 'undefined') return;

        var root = document.getElementById('cart-complementary-products');
        if (!root) {
            destroySwiper();
            return;
        }

        var el = root.querySelector('.cart-complementary-swiper');
        if (!el) return;

        destroySwiper();

        var nextEl = root.querySelector('.cart-complementary-next');
        var prevEl = root.querySelector('.cart-complementary-prev');

        swiperInstance = new Swiper(el, {
            slidesPerView: 1.08,
            spaceBetween: 8,
            watchOverflow: true,
            navigation:
                nextEl && prevEl
                    ? {
                        nextEl: nextEl,
                        prevEl: prevEl,
                    }
                    : undefined,
                    breakpoints: {
            320: {
                slidesPerView: 1.02,
                spaceBetween: 8,
            },
            768: {
                slidesPerView: 1.08,
                spaceBetween: 8,
            },
        }
        });
    }

    function scheduleInit() {
        requestAnimationFrame(function () {
            initCartComplementarySwiper();
        });
    }

    document.addEventListener('DOMContentLoaded', scheduleInit);

    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
            scheduleInit();
        });
    }
})();
